import React from 'react';
import useModal from '../../../../hooks/useModal';
import EventEmitter from '../../../../utils/util/eventEmitter';
import { Modal } from '../../../common';
import { releaseScreenLock } from '../../../common/dialogs/modals/ScreenLock';

const appletModalEmitter = new (class extends EventEmitter<{
  showModal: boolean;
  hideModal: boolean;
}> {})();

export function hideAppletModal() {
  appletModalEmitter.emit('hideModal', true);
  releaseScreenLock();
}
export function showAppletModal() {
  appletModalEmitter.emit('showModal', true);
}

const AppletModal = () => {
  const { show, onClose: hideModal, ...modalProps } = useModal();

  React.useEffect(() => {
    appletModalEmitter.on('hideModal', hideModal);
    appletModalEmitter.on('showModal', show);

    return () => {
      void appletModalEmitter.off('hideModal', hideModal);
      void appletModalEmitter.off('showModal', show);
    };
  }, [show, hideModal]);

  return (
    <Modal
      noHeader
      shouldCloseOnEsc={false}
      shouldCloseOnOverlayClick={false}
      {...modalProps}
      sx={{
        '.modal__content': {
          minWidth: '50vh',
        },
      }}
      initialFocusGetter={(ref) => {
        if (!ref) return false;
        // eslint-disable-next-line no-param-reassign
        (ref.querySelector('iframe') as HTMLElement).style.height = `${
          (
            ref.querySelector('iframe') as HTMLIFrameElement
          ).contentDocument?.body.getBoundingClientRect().height || 200
        }px`;
        return null;
      }}
    >
      <iframe
        tabIndex={0}
        src={window.signatureAppletUrl}
        title={window.TIT_SING_MODAL_LBL}
        sx={{ border: 'none', width: '100%' }}
      />
    </Modal>
  );
};

export default AppletModal;
